import { useMutation } from 'react-query'
import { apiPostEphemeralVehicleTest } from '../api/ephemeral-vehicle-test-result-api'

export const useAddEphemeralVehicleTest = () => {
  return useMutation(({ payload }) => apiPostEphemeralVehicleTest({ payload }))
}
